(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["va-craftsmanship"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('va-craft-film')) {
    customElements.define('va-craft-film', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.button = this.querySelector('button');
        if (!this.video || !this.button || this.abort) return;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.visible = false;
        this.manualPause = false;
        this.video.controls = false;
        this.video.muted = true;
        this.button.hidden = false;
        this.sync = () => {
          const paused = this.video.paused;
          this.button.setAttribute('aria-label', paused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel);
          this.button.querySelector('[data-play]').hidden = !paused;
          this.button.querySelector('[data-pause]').hidden = paused;
        };
        this.tryPlay = () => { this.video.play().catch(() => this.sync()); };
        this.update = () => {
          if (this.visible && !document.hidden && !this.motion.matches && !this.manualPause) this.tryPlay();
          else this.video.pause();
        };
        this.button.addEventListener('click', () => {
          if (this.video.paused) { this.manualPause = false; this.tryPlay(); }
          else { this.manualPause = true; this.video.pause(); }
        }, { signal });
        this.video.addEventListener('play', this.sync, { signal });
        this.video.addEventListener('pause', this.sync, { signal });
        document.addEventListener('visibilitychange', this.update, { signal });
        this.motion.addEventListener('change', this.update, { signal });
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.visible = entries[0].isIntersecting;
            this.update();
          }, { threshold:0.05 });
          this.observer.observe(this);
        } else { this.visible = true; this.update(); }
        this.sync();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.video?.pause();
        this.abort?.abort();
        this.abort = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
